const namedRoutes = {
  home: "/",

  johnPerkins: "/john-perkins/",
  connieWan: "/connie-wan/",
  downloads: "/downloads/",

  archive2025: {
    home: "/2025/",
    ericaFloden: "/2025/erica-floden/",
    jimCline: "/2025/jim-cline/",
    jimClineHoaLetter: "/2025/jim-cline/hoa-letter/",
    rachelLong: "/2025/rachel-long/",
    downloads: "/2025/downloads/",
  },
};

export default namedRoutes;
